export default "__VITE_ASSET__C29VN2vr__"